import { render, staticRenderFns } from "./ndetail.vue?vue&type=template&id=21e34594&"
import script from "./ndetail.vue?vue&type=script&lang=js&"
export * from "./ndetail.vue?vue&type=script&lang=js&"
import style0 from "./ndetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports